import styles from './Tag.module.css';

/**
 * Every state has a word; colour and shape are secondary (ADR 0028).
 * - `pending`: waiting, not started, due, draft (amber tint and outline, hollow dot).
 * - `active`: in progress, active (solid primary blue).
 * - `done`: finished, paid, approved, connected (teal tint, filled dot).
 * - `attention`: held, needs review, needs action (white, amber outline, filled dot).
 * - `failed`: declined, rejected, failed (neutral fill, dark outline; never the danger red).
 * - `neutral`: closed, not in use, other (neutral fill).
 * - `danger`: clinical danger only (for example a documented allergy). Never for money or
 *   overdue items.
 */
export type TagState =
  'pending' | 'active' | 'done' | 'attention' | 'failed' | 'neutral' | 'danger';

export interface TagProps {
  state: TagState;
  /** Always a word. The shape is secondary; meaning never rests on colour or fill alone. */
  children: string;
}

export function Tag({ state, children }: TagProps) {
  return (
    <span className={styles.tag} data-state={state}>
      {children}
    </span>
  );
}
